export {
  default as towels,
  ReactComponent as Towels,
} from '@assets/icons/features-and-amenities/towels.svg'    
